import { useTranslation } from 'react-i18next';

/**
 * "דילוג לתוכן הראשי" (T-12, F-018): the first Tab stop on every app screen.
 * Hidden until focused; moves focus to the main landmark (`main#main`,
 * tabIndex -1) so the next Tab lands inside the page, past the sidebar and
 * the top bar.
 */
export default function SkipLink({ targetId = 'main' }: { targetId?: string }) {
  const { t } = useTranslation();
  return (
    <a
      href={`#${targetId}`}
      onClick={(e) => {
        const target = document.getElementById(targetId);
        if (!target) return;
        e.preventDefault(); // focus without adding "#main" to the URL
        target.focus({ preventScroll: true });
        target.scrollIntoView({ block: 'start' });
      }}
      className="sr-only focus:not-sr-only focus:fixed focus:top-2 focus:start-2 focus:z-toast focus:px-4 focus:py-2
                 focus:rounded-lg focus:bg-surface-0 focus:text-surface-900 focus:text-sm focus:font-medium focus:shadow-float"
    >
      {t('shell.skipToContent')}
    </a>
  );
}
